import React, { useState } from "react";
import "./hostScreen.css";
import BottomBar from "../BottomBar";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { bottomBarActions } from "../../store/bottomBarSlice";
import BackFilledSvgIcon from "../../assets/ReactSvg/BackFilledSvgIcon";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CustomVideoPlayer from "../CustomVideoPlayer/Index";
import HostDetailsComponent from "./HostDetailsComponent";
import { menuActions } from "../../store/menuSlice";
import Experiences from "./Experiences";
import ContentLoader from "react-content-loader";

const CuiratorProfile = () => {
  const dispatch = useDispatch();
  const [viewExperiencePage, setViewExperiencePage] = useState(false);
  const [isFirstMediaLoaded, setIsFirstMediaLoaded] = useState(false);
  const hostList = useSelector((state) => state.host.hostList);
  const hostDetails = hostList[0];

  const { name, role = [], cardImage = [],hostStories =[] } = hostDetails || {};

  const handleFirstMediaLoad = () => {
    setIsFirstMediaLoaded(true);
  };

  const HOST_EXP_DUMMY = [
    {
      "postType": "Video",
      "mediaType": "Video",
      "postUrl": "https://www.instagram.com/p/DPqR3xKLmNo/",
      "mediaUrl": "https://cuirato-images.s3.ap-south-1.amazonaws.com/videos/WhatsAppVideo2026-04-23at17.11.59.mp4",
      "creatorUrl": "https://www.instagram.com/thehungrywanderer/",
      "creatorType": "Creator",
      "creatorName": "The Hungry Wanderer",
      "creatorFollowers": "42k",
      "creatorBio": "📍 Surat\nChasing flavours, one plate at a time 🍜",
      "dishes": [
        "Spicy Miso Ramen"
      ]
    },
    {
      "postType": "List",
      "mediaType": "Video",
      "postUrl": "https://www.instagram.com/p/DPqR9yTUvWx/",
      "mediaUrl": "https://cuirato-images.s3.ap-south-1.amazonaws.com/videos/WhatsAppVideo2026-04-23at17.11.51.mp4",
      "creatorUrl": "https://www.instagram.com/gujaratfoodtrail/",
      "creatorType": "Page",
      "creatorName": "Gujarat Food Trail",
      "creatorFollowers": "78k",
      "creatorBio": "Curating the best bites across Gujarat 🌶️🍛",
      "dishes": []
    },
    {
      "postType": "Meal list",
      "mediaType": "Video",
      "postUrl": "https://www.instagram.com/p/DPqSAaBcDeF/",
      "mediaUrl": "https://cuirato-images.s3.ap-south-1.amazonaws.com/videos/WhatsAppVideo2026-04-23at17.11.15.mp4",
      "creatorUrl": "https://www.instagram.com/foodwithnisha/",
      "creatorType": "Creator",
      "creatorName": "Nisha Eats Out",
      "creatorFollowers": 8920,
      "creatorBio": "Home cook turned food explorer 🍲\nReviews you can trust",
      "dishes": [
        "Ask"
      ]
    },
    {
      "postType": "Video",
      "mediaType": "Video",
      "postUrl": "https://www.instagram.com/p/DPqSGhIjKlM/",
      "mediaUrl": "https://cuirato-images.s3.ap-south-1.amazonaws.com/videos/WhatsAppVideo2026-04-23at17.11.01.mp4",
      "creatorUrl": "https://www.instagram.com/rohanontheroad/",
      "creatorType": "Creator",
      "creatorName": "Rohan On The Road",
      "creatorFollowers": "31.5k",
      "creatorBio": "Travel | Food | Stories from the street 🛺",
      "dishes": [
        "Tonkotsu Ramen",
        "Gyoza"
      ]
    }
  ]


  const onHostClick = () => {
    // TODO: isRoundedDesign
    // dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
    dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
  };

  const onChefClick = (chefId) => {
    dispatch(menuActions.setCurrentChefIdClicked(chefId));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  const onViewAllClick = () => {
    setViewExperiencePage(true);
  };

  const avatarImage =
    hostDetails?.image
  const bio =
    hostDetails?.bio;

  const yearsExperience = hostDetails?.yearsExperience;
  const restaurantsReviewed = hostDetails?.restaurantsReviewed;
  const instagramFollowers = hostDetails?.instagramFollowers;
  
  return (
    <>

      {!viewExperiencePage ? <div className="curatorProfileScreen">
        <div className="curatorHero">

          {!isFirstMediaLoaded && <div className="carousel-skeleton-overlay">
            <ContentLoader
              viewBox="0 0 400 410"
              height={"100%"}
              width="100%"
              backgroundColor="#f0f0f0"
              foregroundColor="#e0e0e0"
            >
              <rect x="0" y="0" rx={16} ry={16} width="400" height="410" />
            </ContentLoader>
          </div>}

          <div className={`cuirator-carousel-wrapper ${isFirstMediaLoaded ? "show" : "hide"}`}>

            <Carousel
              preventMovementUntilSwipeScrollTolerance={true}
              showArrows={false}
              showThumbs={false}
              showStatus={false}
              // showIndicators={!isChefMainScreen}
              // showIndicators={false}
              swipeScrollTolerance={30}
              className="cuirator-custom-carousel"
              // onChange={onChange}
              destroyCarousel
            // onClickItem={onClickItem}
            // onClickThumb={onClickThumb}

            >
              {cardImage.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    // onChefClick(chef)
                  }}
                >
                  {item.url.includes(".mp4") || item.url.includes(".MP4") ? (
                    <div className="carousel-react-player cuirator-custom-video-player">
                      <CustomVideoPlayer
                        videoUrl={item.url}
                        height={220}
                        // onReady={onChefVideoReady}
                        index={index}
                      // handleSetIsVideoReadyToPlay={
                      //   handleSetIsVideoReadyToPlay
                      // }
                      />
                      <div
                        // onClick={() => onChefClick(chef)}
                        className="chefPhotoClickDiv"
                      ></div>
                    </div>
                  ) : (
                    <img
                      // style={{ objectFit: "cover", maxHeight: 400 }}
                      alt=""
                      src={item.url}
                      onLoad={index === 0 ? handleFirstMediaLoad : undefined}
                    />
                  )}
                </div>
              ))}
            </Carousel>
          </div>


          <div onClick={onHostClick} className="curatorBackBtn">
            <BackFilledSvgIcon size={20} />
          </div>
          {/* <div className="curatorHeroCard">
          <p className="curatorHeroText">{bio}</p>
        </div> */}
        </div>

        <div className="curatorProfileInfo">
          <div className="curatorProfileInfoContainer">
            <div className="curatorAvatarWrapper">
              <img className="curatorAvatar" src={avatarImage} alt={name} />
            </div>
            <div className="curatorName Satoshi">{name}</div>
            <div className="curatorRole Satoshi">{role.join(" • ")}</div>
          </div>

          <div className="curatorStatsRow">
            <div className="curatorStatCard">
              <div className="curatorStatValue Satoshi">{yearsExperience}</div>
              <div className="curatorStatLabel Satoshi">Years in food content</div>
            </div>
            <div className="curatorStatCard">
              <div className="curatorStatValue Satoshi">{restaurantsReviewed}</div>
              <div className="curatorStatLabel Satoshi">Restaurant reviewed</div>
            </div>
            <div className="curatorStatCard">
              <div className="curatorStatValue Satoshi">{instagramFollowers}</div>
              <div className="curatorStatLabel Satoshi">Instagram followers</div>
            </div>
          </div>
        </div>

        <HostDetailsComponent
          hostDetails={hostDetails}
          onChefClick={onChefClick}
          onViewAllClick={onViewAllClick}
          showFounders={true}
          expertStoryVideos={hostStories}
          chefName={name}
          chefLabel1={bio}
        />

        <ToastContainer />
        <BottomBar isExplore />
      </div> : <Experiences
        hostExperience={HOST_EXP_DUMMY}
        setViewExperiencePage={setViewExperiencePage}
      />}
    </>
  );
};

export default CuiratorProfile;
